const $ = require("jquery");
const { Foundation, dataLayer } = window;
const FormController = require("../../utilities/_form-controller");
const _ = require("lodash");
const Stepper = require("../stepper/Stepper");
const Form_init = require("../../src/Form_init");

class StepUpYourGameOrContactUsForm {
	constructor (id, utmCookies) {
		this.id = id;
		this.setupForm();
		this.stepper = new Stepper(this.getStepperId());
		this.showChiliPiper = $(`#${this.id}`).data("showchilipiper");
		utmCookies.initForm(this.getForm()[0]);
	}

	setupForm () {
		new Foundation.Abide(this.getForm());

        const $form = this.getForm();

        $form
			.on("formvalid.zf.abide", () => this.submit())
			.on("submit", e => e.preventDefault());

		Form_init($form[0]);
	}

	getRoot () {
		return $(`#${this.id}`);
	}

	getRootElement() {
		return this.getRoot()[0];
	}

	getStepper () {
		return this.getRoot().find("[data-component=stepper]");
	}

	getStepperId () {
		return this.getStepper().attr("id");
	}

	getForm () {
		return this.getRoot().find("form");
	}

	getFormId () {
		return this.getForm().attr("id");
	}

	getCountryField () {
		return this.getForm().find('[name="Country"]');
	}

	getPrivacyPolicyAgreementMessageContainer() {
		return this.getForm().find('[data-component="privacy-policy-agreement-message-container"]');
	}

	getPrivacyPolicyCheckboxContainer() {
		return this.getForm().find('[data-component="privacy-policy-checkbox-container"]');
	}

	getSubmitButton () {
		return this.getForm().find("button[type=submit]");
	}

	disableSubmitButton () {
		this.getSubmitButton().attr("disabled", "true");
	}

	serializeFormData () {
		return _.reduce(
			this.getForm().serializeArray(),
			(data, field) => _.set(data, field.name, field.value),
			{}
		);
	}

	async submit () {
		this.disableSubmitButton();

		this.stepper.nextStep();

		const data = this.serializeFormData();

		try {
			await FormController.marketo__submit(data, this.showChiliPiper, {
				chiliPiperRouter: "nike-router",
				chiliPiperTitle: "Thanks! What time works best for a quick call?",
				chiliPiperFormId: this.getFormId(),
			}, this.getForm());
			dataLayer.push({ event: 'ajaxFormSubmitted' });
		} catch (e) {
			console.error(e);
		} finally {
			this.stepper.nextStep();
		}
	}
}

StepUpYourGameOrContactUsForm.init = (utmCookies) => {
	const objects = [];

	$('[data-component="step-up-your-game-or-contact-us-form"]').each((_, e) => {
		const id = $(e).attr("id");
		objects.push(new StepUpYourGameOrContactUsForm(id, utmCookies));
	});

	return objects;
}

module.exports = StepUpYourGameOrContactUsForm;
